import React from 'react';
import {
    yMapHintContainer, yMapHintDescription, yMapHintDescriptionLite, yMapHintInfo, yMapHintPreview
} from '@search/ymap/src/hint';

import { formatPrice } from '@search/helpers/src/formatPrice';
import { formatArea } from '@search/helpers/src/formatArea';
import { Currency } from '@search/filter-enums/enums/Currency';

import { OfferYMapPlacemarkTooltip } from '../placemark/Placemark';
import { OfferYMapHousePlacemarkProps } from './HousePlacemarkProps';

export function OfferYMapHousePlacemark({
    id,
    price,
    coordinates,
    totalArea,
    landArea,
    rent,
    preview,
    url,
    isActive,
    isVisited,
    isFavorite,
    onClick,
    targetBlank = true,
    isHighlighted,
    zIndexes,
    dataTest
}: OfferYMapHousePlacemarkProps) {
    const areaPriceStr = ! rent && totalArea ? `${formatPrice({
        value: price.value / totalArea.value,
        currency: price.currency,
        displayCurrency: true,
        noFractional: true
    })} за м²` : undefined;

    const rentStr = rent?.untilitesIncluded ? 'КУ включены' : undefined;

    const hintLayout = yMapHintContainer(`
        ${yMapHintPreview(preview)}
        ${yMapHintInfo(`
            ${totalArea ? yMapHintDescription(`${
        formatArea(totalArea)}${landArea ? `, ${formatArea(landArea)}` : ''}`) : ''}
            ${yMapHintDescriptionLite(rentStr ?? areaPriceStr ?? '')}
        `)}
    `);

    const priceStr = formatPrice({
        value: price.rubPrice ?? price.value,
        currency: price.rubPrice ? Currency.RUB : price.currency,
        inWords: true
    });

    return (<OfferYMapPlacemarkTooltip
        id={id}
        url={url}
        isVisited={isVisited}
        isActive={isActive}
        onClick={onClick}
        title={priceStr}
        dataTest={dataTest}
        targetBlank={targetBlank}
        coordinates={{ y: coordinates.latitude, x: coordinates.longitude }}
        hintLayout={hintLayout}
        isHighlighted={isHighlighted}
        zIndexes={zIndexes}
        isFavorite={isFavorite}
    />);
}
